function getNumericValue(value, old_value){
    value = value + '';
    let integer_val = value.replace(/\./g, '');
    integer_val = +integer_val;
    if(Number.isInteger(integer_val)) return value;
    else if(value === '') return 0;
    return old_value;
}

export default getNumericValue;